import { useContext, useState } from "react";
import { Context } from "../../../context/Context";
import { useAccess } from "../../../access/hooks/useAccess";
import { Select } from "../../ui";
import { moveItemAPI } from "../../../utils/api/menu";
import { localized, menuErrorMessage } from "../menuRole";
import { menuActionsText } from "../menuActionsText";
import MenuDialog from "./MenuDialog";

// Moves an item to another live section of the same menu (kept as the same
// item: pricing, additions and branch visibility come along).
export default function MoveItemDialog({ menu, item, sections, currentSectionId, onClose, onSaved }) {
  const { lang } = useContext(Context);
  const { can } = useAccess();
  const t = menuActionsText(lang);
  const options = sections.filter((s) => String(s._id) !== String(currentSectionId)).map((s) => ({ value: String(s._id), label: localized(s.name, lang) }));
  const [target, setTarget] = useState(options[0]?.value || "");
  const [error, setError] = useState("");

  const submit = async () => {
    if (!can("menu.manage", { restaurantId: menu.restaurant?.id })) return;
    setError("");
    try {
      onSaved((await moveItemAPI(menu._id, item._id, target)).menu, t.moved);
      onClose();
    } catch (err) {
      setError(menuErrorMessage(err, lang));
    }
  };

  return (
    <MenuDialog title={`${t.moveTitle} — ${localized(item.name, lang)}`} onClose={onClose} onSubmit={submit} submitLabel={t.move} cancelLabel={t.cancel} submitDisabled={!target} error={error}>
      <Select label={t.targetSection} value={target} options={options} onChange={(e) => setTarget(e.target.value)} />
    </MenuDialog>
  );
}
